import { FormTemplate } from '@src/core';

const ContactForm: FormTemplate = {
  step: {
    questions: {
      name: {
        sequence: 1,
        type: 'text',
        label: 'Nome',
        placeholder: 'Ex: Maria Conceição da Silva',
        validator: {
          dataType: 'string',
          required: true,
        },
        fullWidth: true,
        decoration: true,
      },
      referenceDate: {
        sequence: 2,
        type: 'date',
        fieldType: 'date',
        label: 'Data do parto',
        validator: {
          dataType: 'string',
          required: true,
        },
        decoration: true,
      },
      hospitalName: {
        sequence: 3,
        type: 'radio',
        label: 'Hospital',
        options: ['HOSPITAL A', 'HOSPITAL B', 'HOSPITAL C'],
        validator: {
          dataType: 'string',
          required: true,
        },
        fullWidth: true,
      },
      email: {
        sequence: 3,
        type: 'text',
        fieldType: 'email',
        label: 'E-mail',
        placeholder: 'Ex: exemplo@dominio.com',
        validator: {
          dataType: 'string',
          required: true,
        },
        fullWidth: true,
        decoration: true,
      },
      whatsApp: {
        sequence: 3,
        type: 'text',
        fieldType: 'number',
        label: 'WhatsApp',
        placeholder: 'Ex: 1199999999 (apenas números DDD + número)',
        validator: {
          dataType: 'number',
          required: true,
        },
        fullWidth: true,
        decoration: true,
      },
    },
  },
};

export { ContactForm };
